import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page} 
        subheading=""
        > Size Descriptions</PageHeader>

        <SwitchRow {...page}  keyName= {LocationVarKey.LLMisSizing} label="✨ Enhance with AI" hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisSizing,"1")} />
        <TextRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.LLMisSizing,"1")}>
            <div className="rainbowPower">
            Your AI assistant will enhance the answer below using contextual data from the customer’s profile, conversation history, and your knowledge graph.
            </div>
        </TextRow>

        <SectionHeader {...page}  > Small </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionSmall1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionSmall2}
            enableSwitchVar={LocationVarKey.SizeDescriptionSmall2Enabled}
        />

        <SectionHeader {...page}  > Medium </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionMedium1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionMedium2}
            enableSwitchVar={LocationVarKey.SizeDescriptionMedium2Enabled}
        />

        <SectionHeader {...page}  > Large </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionLarge1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionLarge2}
            enableSwitchVar={LocationVarKey.SizeDescriptionLarge2Enabled}
        />

        <SectionHeader {...page}  > Extra Large </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionExtraLarge1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionExtraLarge2}
            enableSwitchVar={LocationVarKey.SizeDescriptionExtraLarge2Enabled}
        />

        <SectionHeader {...page}  > 1 Bedroom </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription1Bedroom1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription1Bedroom2}
            enableSwitchVar={LocationVarKey.SizeDescription1Bedroom2Enabled}
        />

        <SectionHeader {...page}  > 2 Bedrooms </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription2Bedroom1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription2Bedroom2}
            enableSwitchVar={LocationVarKey.SizeDescription2Bedroom2Enabled}
        /> 

        <SectionHeader {...page}  > 3 Bedrooms </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription3Bedroom1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription3Bedroom2}
            enableSwitchVar={LocationVarKey.SizeDescription3Bedroom2Enabled}
        /> 

        <SectionHeader {...page}  > 4-5 Bedrooms </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription45Bedroom1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription45Bedroom2}
            enableSwitchVar={LocationVarKey.SizeDescription45Bedroom2Enabled}
        /> 

        <SectionHeader {...page}  > 5x5 </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription5x51}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription5x52}
            enableSwitchVar={LocationVarKey.SizeDescription5x52Enabled}
        />

        <SectionHeader {...page}  > 5x10 </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription5x101}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription5x102}
            enableSwitchVar={LocationVarKey.SizeDescription5x102Enabled}
        /> 

        <SectionHeader {...page}  > 10x10 </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription10x101}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription10x102}
            enableSwitchVar={LocationVarKey.SizeDescription10x102Enabled}
        />

        <SectionHeader {...page}  > 10x15 </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription10x151}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription10x152}
            enableSwitchVar={LocationVarKey.SizeDescription10x152Enabled}
        />

        <SectionHeader {...page}  > 10x20 </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription10x201}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription10x202}
            enableSwitchVar={LocationVarKey.SizeDescription10x202Enabled}
        />

        <SectionHeader {...page}  > 10x30 </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescription10x301}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescription10x302}
            enableSwitchVar={LocationVarKey.SizeDescription10x302Enabled}
        />

        <SectionHeader {...page}  > Small Vehicle </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionSmallVehicle1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionSmallVehicle2}
            enableSwitchVar={LocationVarKey.SizeDescriptionSmallVehicle2Enabled}
        /> 

        <SectionHeader {...page}  > Motorcycle </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionMotorcycle1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionMotorcycle2}
            enableSwitchVar={LocationVarKey.SizeDescriptionMotorcycle2Enabled}
        />

        <SectionHeader {...page}  > Sedan </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionSedan1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionSedan2}
            enableSwitchVar={LocationVarKey.SizeDescriptionSedan2Enabled}
        />

        <SectionHeader {...page}  > Truck </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionTruck1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionTruck2}
            enableSwitchVar={LocationVarKey.SizeDescriptionTruck2Enabled}
        /> 

        <SectionHeader {...page}  > RV </SectionHeader>
        <TextAreaRow {...page}  
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.SizeDescriptionRV1}
        />
        <TextAreaRow {...page}  
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.SizeDescriptionRV2}
            enableSwitchVar={LocationVarKey.SizeDescriptionRV2Enabled}
        />    
    </>
}